import { computed } from 'vue'
import { useMeta } from 'vue-meta'
import { i18n } from './i18n'

export default function i18nMetaInfo(i18nPathPrefix) {
    const prefix = `${i18nPathPrefix ? i18nPathPrefix + '.' : ''}meta`

    useMeta(computed(() => {
        return { title: i18n.t(`${prefix}.title`) }
    }))
}